module.exports = __webpack_public_path__ + "static/j2-d71a8cfaf3db5350cfe28bbba57cc152.png";